<section class="irrigator-auth-panel certificate-callback" aria-labelledby="certificate-callback-title">
  <div class="certificate-auth">
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 22s7-3.2 7-10V5l-7-3-7 3v7c0 6.8 7 10 7 10Z" />
      <path d="m9 12 2 2 4-5" />
    </svg>
    <h1 id="certificate-callback-title">Completando autenticacion</h1>
    <p>{{ error || 'Estamos validando el acceso con certificado digital.' }}</p>

    @if (error) {
      <button type="button" class="auth-submit" (click)="backRequested.emit()">
        Volver al acceso de comuneros
      </button>
    }
  </div>
</section>
